import { ConnectionName, ConnectionType } from "@arelia-types/connection";

export const authWindowName = "externalAuth";

export const ConnectionTypeMap = {
  [ConnectionName.arelia]: null,

  [ConnectionName.amazon]: [ConnectionType.streaming],
  [ConnectionName.appleMusic]: [ConnectionType.streaming],
  [ConnectionName.pandora]: [ConnectionType.streaming],
  [ConnectionName.spotify]: [ConnectionType.streaming],

  [ConnectionName.distrokid]: [ConnectionType.earnings],
  [ConnectionName.square]: [ConnectionType.earnings],
  [ConnectionName.shopify]: [ConnectionType.earnings],
  [ConnectionName.songtrust]: [ConnectionType.earnings],
  [ConnectionName.cdBaby]: [ConnectionType.earnings],
  [ConnectionName.ascap]: [ConnectionType.earnings],

  [ConnectionName.facebook]: [ConnectionType.social],
  [ConnectionName.instagram]: [ConnectionType.social],
  [ConnectionName.tiktok]: [ConnectionType.social],
  [ConnectionName.twitter]: [ConnectionType.social],

  [ConnectionName.youtube]: [ConnectionType.social, ConnectionType.streaming],
}
